import { useContext, useEffect, useState } from "react"
import { BEConfigurationContext } from "stores"
import { numberFormatter } from "components/helpers"
import { CurrencyModel } from "components/pages/maintanance/currency/currencyList/currencyList.models"

export const formatCurrencyValue = (
  value: number,
  defaultCurrency: CurrencyModel,
  fallback = "£0.00"
): string => {
  if (!defaultCurrency) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    }).format(value)
  }

  const { symbol } = defaultCurrency

  if (value === 0) return fallback

  if (value < 0) {
    return `-${symbol}${numberFormatter.numberFormatter.format(
      Math.abs(value)
    )}`
  }

  return symbol + numberFormatter.numberFormatter.format(value)
}

const useCurrencyFormatter = (
  data: number,
  optionalResultWhenDataIs0?: string
) => {
  const [numberWithCurrency, setNumberWithCurrency] = useState<string>("")
  const { tenantConfiguration } = useContext(BEConfigurationContext)

  useEffect(() => {
    const { defaultCurrency } = tenantConfiguration
    const formatted = formatCurrencyValue(
      data,
      defaultCurrency,
      optionalResultWhenDataIs0
    )
    setNumberWithCurrency(formatted)
  }, [data, optionalResultWhenDataIs0, tenantConfiguration])

  return data === 0 && optionalResultWhenDataIs0 !== undefined
    ? optionalResultWhenDataIs0
    : numberWithCurrency
}

export default useCurrencyFormatter
